var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"mapRef",staticClass:"map"},[(_vm.ready)?_vm._t("default",null,{"map":_vm.map,"layer":_vm.map}):_vm._e()],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }